import { Box } from '@packages/shared';
// eslint-disable-next-line import/no-cycle
import ComponentRecognizerFooter from './ComponentRecognizerFooter';
import type { FooterBlockImageType } from './types';

type BlockImageProps = {
  data: FooterBlockImageType;
};

export enum BlockImageTestIds {
  main = 'block-image',
}

const BlockImage = ({ data }: BlockImageProps) => (
  <Box
    sx={{
      '& .dangerously-html': {
        width: 'auto',
        display: 'inline-flex',
        alignContent: 'center',
        flexShrink: 0,
        verticalAlign: 'top',
      },
    }}
    data-testid={BlockImageTestIds.main}
    key={`${BlockImageTestIds.main}-${data.id}`}
  >
    {data.paragraph?.map((item, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <ComponentRecognizerFooter key={index} item={item} />
    ))}
  </Box>
);

// eslint-disable-next-line import/no-default-export
export default BlockImage;
